/**
 * Mobile container for the assistant chat.
 *
 * On desktop the same conversation lives as a tab in the SidePane, where it persists beside
 * search; a phone has no room for a persistent side pane, so it gets a drawer.
 */

import { Close } from '@mui/icons-material'
import { Box, Drawer, IconButton, Stack, Typography } from '@mui/material'
import React from 'react'

import AssistantChat from './AssistantChat'
import type { ApplyProposalAction } from './ContentProposalReview'

export interface AssistantPaneProps {
  open: boolean
  onClose: () => void
  bookId: string
  filename?: string
  startBlockId?: string
  markedText?: string
  direction: 'ltr' | 'rtl'
  onApplyProposal?: ApplyProposalAction
  onGoTo?: (filename: string, blockId: string, text: string) => void
}

const AssistantPane: React.FC<AssistantPaneProps> = ({
  open,
  onClose,
  bookId,
  filename,
  startBlockId,
  markedText,
  direction,
  onGoTo,
  onApplyProposal,
}) => (
  <Drawer anchor="bottom" open={open} onClose={onClose} PaperProps={{ sx: { width: '100%', height: '85vh' } }}>
    <Box dir={direction} sx={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0 }}>
      <Stack direction="row" alignItems="center" spacing={1} sx={{ p: 1.5, borderBottom: 1, borderColor: 'divider' }}>
        <Typography variant="subtitle1" sx={{ flexGrow: 1, fontWeight: 600 }}>
          שיחה
        </Typography>
        <IconButton size="small" onClick={onClose} aria-label="סגור">
          <Close fontSize="small" />
        </IconButton>
      </Stack>

      <Box sx={{ flexGrow: 1, minHeight: 0 }}>
        <AssistantChat
          onApplyProposal={onApplyProposal}
          bookId={bookId}
          filename={filename}
          startBlockId={startBlockId}
          markedText={markedText}
          direction={direction}
          onGoTo={
            onGoTo &&
            ((file, blockId, text) => {
              // The drawer covers the manuscript, so navigating means getting out of the way.
              onClose()
              onGoTo(file, blockId, text)
            })
          }
        />
      </Box>
    </Box>
  </Drawer>
)

export default AssistantPane
